module.exports = __webpack_public_path__ + "3fed82ac1154b79cfb870ea28f37e86b.jpg";